import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { API_URL } from '../../api';
import { useAuth } from '../../contexts/AuthContexte';
import MaintenancePage from '../pages/MaintenancePage';

// Routes du retour OAuth : elles doivent rester accessibles pour que les comptes autorisés puissent se connecter
const CALLBACK_PATHS = ['/callback', '/auth/discord/callback'];

/**
 * Affiche la page de maintenance à la place du site, sauf pour les comptes autorisés
 * (le statut et la liste des comptes autorisés sont gérés par le backend).
 */
const MaintenanceGate = ({ children }) => {
    const { token, loading } = useAuth();
    const location = useLocation();
    const [status, setStatus] = useState(null);

    useEffect(() => {
        if (loading) return;
        let cancelled = false;
        // fetch plutôt que l'instance axios : son intercepteur redirige vers / sur 401 (boucle de rechargement)
        fetch(`${API_URL}/api/maintenance`, {
            headers: token ? { Authorization: `Bearer ${token}` } : {},
        })
            .then(res => { if (!res.ok) throw new Error(res.status); return res.json(); })
            .then(data => { if (!cancelled) setStatus(data); })
            .catch(() => { if (!cancelled) setStatus({ enabled: true, bypass: false }); });
        return () => { cancelled = true; };
    }, [token, loading]);

    if (CALLBACK_PATHS.includes(location.pathname)) return children;
    if (!status) return null;
    if (status.enabled && !status.bypass) return <MaintenancePage />;
    return children;
};

export default MaintenanceGate;
